import React, { useState, useEffect } from "react";
import { useParams, useLocation, useNavigate } from "react-router-dom";
import "../Styles/ReviewBooking.css";
import Navber from "../Components/Navber.jsx";
import api from "../Api.js";
import { showToast } from "./PopupMessage.jsx";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faAngleDown, faAngleUp } from "@fortawesome/free-solid-svg-icons";
import FullscreenSpinner from "./Helping Component/Fullscreeenspinner.jsx";

function formatDate(dateString) {
  const date = new Date(dateString);


  const days = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];
  const months = [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December",
  ];

  const dayName = days[date.getDay()];
  const day = date.getDate();
  const monthName = months[date.getMonth()];

  const getOrdinal = (n) => {
    if (n % 10 === 1 && n % 100 !== 11) return n + "st";
    if (n % 10 === 2 && n % 100 !== 12) return n + "nd";
    if (n % 10 === 3 && n % 100 !== 13) return n + "rd";
    return n + "th";
  };

  return `${dayName} ${getOrdinal(day)} ${monthName}`;
}

function calculateNights(checkIn, checkOut) {
  const inDate = new Date(checkIn);
  const outDate = new Date(checkOut);
  const diffTime = outDate - inDate;
  return Math.ceil(diffTime / (1000 * 60 * 60 * 24));
}

const ReviewBooking = () => {
  const [couponCode, setCouponCode] = useState(null);
  const [information, setInformation] = useState(true);
  const [totaldiscount, setTotaldiscount] = useState(0);
  const [loading, setLoading] = useState(false);

  const [applied, setApplied] = useState(false);
  const { bookingID } = useParams();
  const location = useLocation();
  const [tours, setTours] = useState(null);
  const navigate = useNavigate();
  const [policyChecked, setPolicyChecked] = useState(false);
  // STATIC BOOKING DATA (used if no bookingDetails from state)
  const staticBookingDetails = {
    check_in: "2025-09-20",
    check_out: "2025-09-23",
    adults: 2,
    total_guests: 2,
    total_price: 7500, // total for stay
  };

  const { bookingDetails = staticBookingDetails } = location.state || {};
  console.log("bookingDetails from state : ", bookingDetails)


  const adminToken = localStorage.getItem("accessTok");
  const FranchiseData = JSON.parse(localStorage.getItem("franchiseData")) || {};
  const customer_id = FranchiseData?.customer?.id || null;
  const franchise_id = FranchiseData?.franchise?.id || null;

  const applyCoupon = async () => {
    try {
      const CouponData = {
        code: couponCode,
        booking_type: "Tour",
        amount: bookingDetails?.total_amount,
      };
      console.log("CouponData: ", CouponData);
      const response = await api.post("/admin/coupons/validate", CouponData, {
        headers: {
          "Content-Type": "application/json",
          "X-ADMIN-TOKEN": `${adminToken}`,
        },
      });
      if (response.data.status === true) {
        setTotaldiscount(response?.data?.discount);
        showToast("Coupon Applied Successfully...", "success");
        // setApplied(true);
      }
    } catch (err) {
      console.log(err);
    }
  };

  const nights = calculateNights(
    bookingDetails.tour_start_date,
    bookingDetails.tour_end_date
  );
  const perNightPrice = bookingDetails.total_amount / nights;
  const finalPrice = bookingDetails.total_amount - totaldiscount;



  // guest Information
  const [profile, setProfile] = useState(false);
  const customer = JSON.parse(localStorage.getItem("customer")) || {};

  const profileData = {
    title: "Mr.",
    firstName: customer.name,
    lastName: "Shaikh",
    email: customer.email,
    phone: customer.mobile,
  };

  // initial state: one guest row
  const [guests, setGuests] = useState([
    { title: "", firstName: "", email: "", phone: "", sameAsProfile: false },
  ]);

  // Add a new guest row
  const handleAddGuest = () => {
    setGuests([
      ...guests,
      { title: "", firstName: "", email: "", phone: "", sameAsProfile: false },
    ]);
  };

  // Remove guest row by index
  const handleRemoveGuest = (index) => {
    const newGuests = guests.filter((_, i) => i !== index);
    setGuests(newGuests);
  };

  // Handle input change
  const handleChange = (index, field, value) => {
    const newGuests = [...guests];
    newGuests[index][field] = value;
    setGuests(newGuests);
  };

  // Handle checkbox “Same as Profile Information”
  const handleSameAsProfile = (index, checked) => {
    setProfile(checked);
    const newGuests = [...guests];
    newGuests[index].sameAsProfile = checked;

    if (checked) {
      // copy profile data to inputs
      newGuests[index] = {
        ...newGuests[index],
        ...profileData,
        sameAsProfile: true,
      };
    } else {
      // clear data if unchecked
      newGuests[index] = {
        title: "",
        firstName: "",
        lastName: "",
        email: "",
        phone: "",
        sameAsProfile: false,
      };
    }
    setGuests(newGuests);
  };

  useEffect(() => {
    const fetchTour = async () => {
      try {
        const response = await api.get(`/tours/${bookingDetails?.tour_id}/details`);
        if (response.data?.success === true) {
          setTours(response?.data?.data?.tour)
        }

      } catch (error) {

      }
    }
    fetchTour();

  }, [])
const handleNavigateAfterPayment = () => {
  // Optional: save bookingID to localStorage or send to backend
  // localStorage.setItem("bookingID", bookingDetails?.id);

  // Redirect to admin bookings page
  window.location.href = "https://admin.jayrajgroup.org/admin/tour_bookings";
};


  // Tour Booking
  // 🔹 Razorpay Payment Integration
  const handlePayment = async () => {


    if (!bookingDetails?.id) return;

    try {
      const payload = {
        booking_id: bookingDetails?.id,
        discount_amount: totaldiscount,
        customer_id: customer_id,
        franchise_id: franchise_id
      };
      setLoading(true);
      console.log("Initiating payment with payload:", payload);
      const order = await api.post(
        `/admin/payments/manual/tour`,
        payload,
        {
          headers: {
            "Content-Type": "application/json",
             "X-ADMIN-TOKEN": `${adminToken}`,
          },
        }
      );

      console.log("Booking created:", order);


    //   const notificationload = {
    //     customer_id: customer.id,
    //     booking_id: bookingDetails?.id,
    //     amount: finalPrice,
    //     payment_id: response.razorpay_payment_id

    //   }
    //   console.log("Sending notification with payload:", notificationload);
    //  const response =  await api.post("/notifications/tour-payment",

    //     notificationload

    //     , {
    //       headers: {
    //         "Content-Type": "application/json",
    //         "Authorization": `Bearer ${adminToken}`,
    //       },
    //     }
    //   );
    //   console.log("notification sent");
      showToast("Booking Successfully Done!", "success");
      handleNavigateAfterPayment();
    } catch (err) {
      console.error("Payment initiation error:", err);
      showToast("Payment initialization failed", "error");
    }
  };







  return (
    <>
      <div style={{ backgroundColor: "#f0f0f0" }}>
        <Navber />
      </div>
      {/* {loading && <FullscreenSpinner />} */}
      <div className="reviewBooking-container">
        <div className="reviewBooking-title">Review your Booking</div>

        <div className="reviewBooking-main">
          {/* Left Section */}
          <div className="reviewBooking-left">
            {/* Hotel Details */}
            <div className="reviewBooking-card animate-fadeIn">
              <h3 className="hotel-title">{tours?.title}</h3>
              <div className="hotel-stars">★★★★★</div>
              <p className="hotel-address">
                {tours?.destination?.name}
              </p>

              <div className="checkin-checkout">
                <div>
                  <p style={{ margin: "0" }}>Start Date</p>
                  <strong>{formatDate(bookingDetails.tour_start_date)}</strong>
                  {/* <p style={{ margin: "0" }}>2 PM</p> */}
                </div>
                <div>
                  <p style={{ margin: "0" }}>End Date</p>
                  <strong>{formatDate(bookingDetails.tour_end_date)}</strong>
                  {/* <p style={{ margin: "0" }}>11 AM</p> */}
                </div>
                <div className="booking-summary">
                  <p style={{ margin: "0" }}>
                    {nights} Days | {bookingDetails.adults} Adults |
                  </p>
                  <p style={{ margin: "0" }}>
                    Total Guest: {bookingDetails.seats}
                  </p>
                </div>
              </div>
            </div>

            {/* Important Info */}
            <div className="reviewBooking-card animate-slideUp">
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  cursor: "pointer",
                }}
                onClick={() => setInformation(!information)}
              >
                <span style={{ fontWeight: "600" }}>Important Information</span>
                {information ? (
                  <FontAwesomeIcon icon={faAngleUp} />
                ) : (
                  <FontAwesomeIcon icon={faAngleDown} />
                )}
              </div>
              {information ? (
                <ul style={{ transition: "2s" }}>
                  <li>Primary Guest should be at least 18 years of age.</li>
                  <li>
                    Passport, Aadhaar and Driving License are accepted as ID
                    proof(s)
                  </li>
                  <li>Pets are not allowed</li>
                  <li>
                    Optional: Fee for buffet breakfast: INR 500 for adults and
                    INR 350 for children (approx.)
                  </li>
                  <li>Airport Shuttle fee: INR 1500 per vehicle (one way)</li>
                  <li>Early check-in fee: INR 1000 (subject to availability)</li>
                  <li>Late check-out fee: INR 1000 (subject to availability)</li>
                  <li>Refund is not applicable for this booking </li>
                  <li>
                    Date change allowed once without penalty (until 24 hrs
                    before check-in)
                  </li>
                </ul>
              ) : (
                ""
              )}
            </div>

           


            {/* Agreement */}
            <div className="terms-section">
              <label>
                <input
                  type="checkbox"
                  checked={policyChecked}
                  onChange={(e) => setPolicyChecked(e.target.checked)}
                />{" "}
                By proceeding, I agree to Jayraj Group’s{" "}
                <span
                  onClick={() => navigate("/user-agreement")}
                  style={{ color: "blue", cursor: "pointer", textDecoration: "underline" }}
                >
                  User Agreement
                </span>
                ,{" "}
                <span
                  onClick={() => navigate("/terms-of-services")}
                  style={{ color: "blue", cursor: "pointer", textDecoration: "underline" }}
                >
                  Terms of Service
                </span>{" "}
                and{" "}
                <span
                  onClick={() => navigate("/cancellation-policy")}
                  style={{ color: "blue", cursor: "pointer", textDecoration: "underline" }}
                >
                  Cancellation & Property Booking Policies
                </span>
                .
              </label>
            </div>

            <div className="pay-now-btn">
              <span className="pay-now-btn-price">
                ₹{finalPrice}
              </span>
              <button onClick={handlePayment}>Pay Now</button>
            </div>
          </div>

          {/* Right Section */}
          <div className="reviewBooking-right">
            <div className="reviewBooking-card animate-slideUp">
              <h4>Price Breakup</h4>
              <ul className="price-breakup">
                <li style={{ display: "flex", justifyContent: "space-between" }}>
                  <span>Invoice No.</span>
                  <span>{bookingDetails?.invoice_no}</span>
                </li>
                <li style={{ display: "flex", justifyContent: "space-between" }}>
                  <span>{` ${nights} Days`}</span>
                  <span>₹{bookingDetails?.total_amount}</span>
                </li>
                <li style={{ display: "flex", justifyContent: "space-between" }}>
                  <span>Paid Amount</span>
                  <span>₹{bookingDetails?.paid_amount}</span>
                </li>
                <li style={{ display: "flex", justifyContent: "space-between" }}>
                  <span>Total Discount</span>
                  <span>₹{totaldiscount}</span>
                </li>
                <li style={{ display: "flex", justifyContent: "space-between" }}>
                  <span>Price After Discount</span>
                  <span>₹{finalPrice}</span>
                </li>
                <li style={{ display: "flex", justifyContent: "space-between" }}>
                  <span>Taxes & Service Fees</span>
                  <span>₹0</span>
                </li>
                <li style={{ display: "flex", justifyContent: "space-between" }}>
                  <span>Status</span>
                  <span>{bookingDetails?.status}</span>
                </li>
                <li style={{ display: "flex", justifyContent: "space-between" }}>
                  <span>Payment Status</span>
                  <span>{bookingDetails?.payment_status}</span>
                </li>
                <li
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    fontWeight: "600",
                  }}
                >
                  <span>Total Amount</span>
                  <span>₹{finalPrice}</span>
                </li>
                {/* <li style={{ fontSize: "0.8rem", fontWeight: "700" }}>***Please pay 30% online in advance to complete booking. The remaining 70% must be paid before checkout.***</li> */}
              </ul>
            </div>

             <div className="reviewBooking-card animate-fadeIn">
              <h4>Coupon Codes</h4>
              <div className="reviewBooking-card-input-container">
                <input
                  type="text"
                  placeholder="Enter Your Coupon Code here"
                  value={couponCode}
                  onChange={(e) => setCouponCode(e.target.value)}
                />
                <button onClick={applyCoupon} disabled={applied}>
                  {applied ? "Applied" : "Apply"}
                </button>
              </div>
            </div> 
          </div>
          <div className="terms-section" id="terms-section-id">
            <label>
              <input
                type="checkbox"
                checked={policyChecked}
                onChange={(e) => setPolicyChecked(e.target.checked)}
              />{" "}
              By proceeding, I agree to Jayraj Group’s{" "}
              <span
                onClick={() => navigate("/user-agreement")}
                style={{ color: "blue", cursor: "pointer", textDecoration: "underline" }}
              >
                User Agreement
              </span>
              ,{" "}
              <span
                onClick={() => navigate("/terms-of-services")}
                style={{ color: "blue", cursor: "pointer", textDecoration: "underline" }}
              >
                Terms of Service
              </span>{" "}
              and{" "}
              <span
                onClick={() => navigate("/cancellation-policy")}
                style={{ color: "blue", cursor: "pointer", textDecoration: "underline" }}
              >
                Cancellation & Property Booking Policies
              </span>
              .
            </label>
          </div>


        </div>
      </div>
    </>
  );
};

export default ReviewBooking;
